import type {TSite} from "services-comun-meteored/modules/portal/tiempo";

import {Configuracion as ConfiguracionBase, ConfiguracionBuilder as ConfiguracionBuilderBase} from "../base-config";
import type {Dominio} from "..";

interface IConfiguracion {
    base: string;
    servicesMR: string;
}

const CONFIGURACION_DEFAULT = {
    servicesMR: "services.meteored.com",
};
const CONFIGURACION: Record<TSite, IConfiguracionEspecifica> = {
    ar: {
        base: "meteored.com.ar",
    },
    at: {
        base: "daswetter.at",
    },
    bo: {
        base: "meteored.com.bo",
    },
    br: {
        base: "tempo.com",
    },
    ca: {
        base: "theweather.net",
    },
    cl: {
        base: "meteored.cl",
    },
    cr: {
        base: "meteored.cr",
    },
    de: {
        base: "daswetter.com",
    },
    do: {
        base: "meteored.do",
    },
    ec: {
        base: "meteored.com.ec",
    },
    en: {
        base: "yourweather.co.uk",
    },
    es: {
        base: "tiempo.com",
    },
    eu: {
        base: "theweather.com",
    },
    fr: {
        base: "tameteo.com",
    },
    hn: {
        base: "meteored.hn",
    },
    it: {
        base: "ilmeteo.net",
    },
    mx: {
        base: "meteored.mx",
    },
    nl: {
        base: "tameteo.nl",
    },
    pa: {
        base: "meteored.com.pa",
    },
    pe: {
        base: "meteored.pe",
    },
    pt: {
        base: "tempo.pt",
    },
    py: {
        base: "meteored.com.py",
    },
    ru: {
        base: "pogoda.com",
    },
    uy: {
        base: "meteored.com.uy",
    },
    ve: {
        base: "meteored.com.ve",
    },
}

type IConfiguracionDefault = Pick<IConfiguracion, keyof typeof CONFIGURACION_DEFAULT>;
type IConfiguracionEspecifica = Omit<IConfiguracion, keyof IConfiguracionDefault> & Partial<IConfiguracionDefault>;

class Configuracion extends ConfiguracionBase<IConfiguracion> implements IConfiguracion {
    /* INSTANCE */
    public get base(): string       { return this.data.base; }
    public get services(): string   { return `services.${this.data.base}`; }
    public get servicesMR(): string { return this.data.servicesMR; }
    public get www(): string        { return `www.${this.data.base}`; }

    public constructor(site: TSite) {
        const data = {
            ...CONFIGURACION_DEFAULT,
            ...CONFIGURACION[site],
        }
        super("config", site, {
            ...data,
        });
    }
}

class ConfiguracionBuilder extends ConfiguracionBuilderBase<IConfiguracion> {
    /* INSTANCE */
    public constructor() { super(); }
    protected build(site: TSite): Configuracion { return new Configuracion(site); }
    public override getDominio(dominio: Dominio): Configuracion { return super.getDominio(dominio) as Configuracion; }
    public override getSite(site: TSite): Configuracion { return super.getSite(site) as Configuracion; }
}

export {type Configuracion};
export default new ConfiguracionBuilder();
